import { SquareCheckIcon, SquareXIcon } from 'lucide-react'

import { RiskQuestionnaireQuestionThreadActivity } from '@/gen/inventory/v1/control_service_pb'

import { RISK_QUESTIONNAIRE_THREAD_LABELS } from '@/pages/control/labels'

import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'
import { IsSuggestionAcceptedBadge } from '@/components/shared/is-suggestion-accepted-badge/is-suggestion-accepted-badge'
import { ThreadActivityRow } from '@/components/shared/thread-activity-row/thread-activity-row'

type ActivityTimelineItemProps = {
  activity: RiskQuestionnaireQuestionThreadActivity
}

// Adds the status badges the tenant sees; the portal renders the same row without them.
export const ActivityTimelineItem = ({ activity }: ActivityTimelineItemProps) => (
  <ThreadActivityRow activity={activity}>
    {activity.isLemaSuggestionAccepted !== undefined && (
      <IsSuggestionAcceptedBadge isSuggestionAccepted={activity.isLemaSuggestionAccepted} />
    )}
    {activity.markedAsResolved !== undefined && (
      <TextWithIcon
        text={
          activity.markedAsResolved
            ? RISK_QUESTIONNAIRE_THREAD_LABELS.MARKED_AS_RESOLVED_ACTIVITY
            : RISK_QUESTIONNAIRE_THREAD_LABELS.UNMARKED_AS_RESOLVED_ACTIVITY
        }
        icon={
          activity.markedAsResolved ? (
            <SquareCheckIcon className='text-main-foreground-success' size={14} />
          ) : (
            <SquareXIcon className='text-main-foreground-danger' size={14} />
          )
        }
      />
    )}
  </ThreadActivityRow>
)
